import { useMutation } from "@tanstack/react-query";
import { public_iam_api_requests } from "..";
import {
  BrowserFingerprintDTO,
  CreateBrowserFingerprintRequest,
} from "./types";

const PATH = "/browser-fingerprints";

// Create Browser Fingerprint
export const useCreateBrowserFingerprint = () => {
  return useMutation({
    mutationFn: async (request: CreateBrowserFingerprintRequest) => {
      const response =
        await public_iam_api_requests.post<BrowserFingerprintDTO>(
          PATH,
          request
        );
      return response.data;
    },
  });
};
